export default "/fonts/vendor/mdui/dist/roboto/Roboto-ThinItalic.woff2?271f60b07567ee405bb46112957fa3cb";